var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 371,
    viewBox: "0 0 371 371",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.637 129.549C301.409 147.69 301.409 185.31 301.409 185.31C301.409 185.31 301.602 223.117 296.637 241.258C293.962 251.188 286.133 259.02 276.203 261.692C258.063 266.656 185.5 266.656 185.5 266.656C185.5 266.656 112.937 266.656 94.7964 261.881C85.0566 259.209 77.0349 251.188 74.363 241.258C69.5879 223.117 69.5879 185.5 69.5879 185.5C69.5879 185.5 69.5879 147.69 74.363 129.742C77.0378 119.812 84.867 111.98 94.7964 109.308C113.127 104.344 185.5 104.344 185.5 104.344C185.5 104.344 258.063 104.344 276.203 109.119C286.133 111.791 293.962 119.62 296.637 129.549Z",
    fill: "#FE4545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.395 150.747L222.735 185.5L162.395 220.253V150.747Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeBtn);
export default __webpack_public_path__ + "static/media/youtube_btn.28a9706929e7bbaabd2976940ccfe977.svg";
export { ForwardRef as ReactComponent };